import React from "react";

// background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)),
//     url(../public/images/pensiunea-aron.png) center/cover no-repeat;

const Home = () => {
  return (
    <section className="home" id="home">
      <h1>PENSIUNEA ARON</h1>
      <h2>Bran</h2>
      <a href="#contact">Rezervari</a>
    </section>
  );
};

export default Home;
